<template>
    <div id="header-payment-posting-entry-container">
        <MdTitle
            v-bind:Text="$t('PostPayment.Manual.HeaderEntry')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.PaymentMethod')"
                    v-bind:Options="paymentTypeOptions"
                    v-bind:Model="paymentTypeVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPaymentType"
                    :isRequired="true"
                    :isValid="paymentTypeValid"
                    :Name="'payment-type'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.PayReference')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'payment-reference'"
                    v-bind:MaxLengthProp="50"
                    v-model="parameters.paymentReference"
                    v-bind:Id="'payment-reference'"
                    :isRequired="true"
                    :isValid="paymentReferenceValid"
                    @change="editChanged"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('ClaimBatchStatus.payDate')"
                    :Model="parameters.paymentDate"
                    @input="datePaymentInput"
                    :Id="'payment-date'"
                    :Type="'date'"
                    :isConfirm="false"
                    :isRequired="true"
                    :isValid="paymentDateValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('PatientClaimList.AmountPay')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'payment-amount'"
                    v-model.number="parameters.paymentAmount"
                    v-bind:Id="'payment-amount'"
                    @change="editChanged"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="editMode">
                <MdEdit
                    v-bind:Label="$t('Shared.TransactionNo')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'payment-trans-no'"
                    v-model.number="parameters.transNo"
                    v-bind:Id="'payment-trans-no'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('PostPayment.Manual.EntryDate')"
                    :Model="parameters.sysDate"
                    :Id="'sys-date'"
                    :Type="'date'"
                    :isConfirm="false"
                    :isRequired="false"
                    :ReadOnly="true"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.ToApply')"
                    :TypeProp="'number'"
                    :Name="'to-apply'"
                    :value="toApply"
                    :Id="'to-apply'"
                    :isReadOnly="true"
                />
            </b-col>
        </b-row>
        <!--
        <MdTitle
            v-bind:Text="$t('PostPayment.Manual.GrandTotals')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.NoOfPat')"
                    :TypeProp="'number'"
                    :Name="'no-of-pat'"
                    :value="numberOfPat"
                    :Id="'no-of-pat'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Unpaid')"
                    :TypeProp="'number'"
                    :Name="'unpaid'"
                    :value="unpaid"
                    :Id="'unpaid'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.ToApply')"
                    :TypeProp="'number'"
                    :Name="'to-apply'"
                    :value="toApply"
                    :Id="'to-apply'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Allowed')"
                    :TypeProp="'number'"
                    :Name="'allowed'"
                    :value="allowed"
                    :Id="'allowed'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Adj')"
                    :TypeProp="'number'"
                    :Name="'adj'"
                    :value="adj"
                    :Id="'adj'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Coins')"
                    :TypeProp="'number'"
                    :Name="'coins'"
                    :value="coins"
                    :Id="'coins'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Deductible')"
                    :TypeProp="'number'"
                    :Name="'deductible'"
                    :value="deductible"
                    :Id="'deductible'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Denied')"
                    :TypeProp="'number'"
                    :Name="'denied'"
                    :value="denied"
                    :Id="'denied'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Applied')"
                    :TypeProp="'number'"
                    :Name="'applied'"
                    :value="applied"
                    :Id="'applied'"
                    :isReadOnly="true"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('PostPayment.Manual.PatientTotals')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.NoOfPat')"
                    :TypeProp="'number'"
                    :Name="'patient-no-of-pat'"
                    :value="numberOfPatOfSelectedPatient"
                    :Id="'patient-no-of-pat'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Unpaid')"
                    :TypeProp="'number'"
                    :Name="'patient-unpaid'"
                    :value="unpaidOfSelectedPatient"
                    :Id="'patient-unpaid'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.ToApply')"
                    :TypeProp="'number'"
                    :Name="'patient-to-apply'"
                    :value="toApplyOfSelectedPatient"
                    :Id="'patient-to-apply'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Allowed')"
                    :TypeProp="'number'"
                    :Name="'patient-allowed'"
                    :value="allowedOfSelectedPatient"
                    :Id="'patient-allowed'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Adj')"
                    :TypeProp="'number'"
                    :Name="'patient-adj'"
                    :value="adjOfSelectedPatient"
                    :Id="'patient-adj'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Coins')"
                    :TypeProp="'number'"
                    :Name="'patient-coins'"
                    :value="coinsOfSelectedPatient"
                    :Id="'patient-coins'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Deductible')"
                    :TypeProp="'number'"
                    :Name="'patient-deductible'"
                    :value="deductibleOfSelectedPatient"
                    :Id="'patient-deductible'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Denied')"
                    :TypeProp="'number'"
                    :Name="'patient-denied'"
                    :value="deniedOfSelectedPatient"
                    :Id="'patient-denied'"
                    :isReadOnly="true"
                />
            </b-col>
            <b-col lg="2" md="2" sm="4">
                <MdEdit
                    :Label="$t('PostPayment.Manual.Applied')"
                    :TypeProp="'number'"
                    :Name="'patient-applied'"
                    :value="appliedOfSelectedPatient"
                    :Id="'patient-applied'"
                    :isReadOnly="true"
                />
            </b-col>
        </b-row>
-->
        <MdTitle
            v-bind:Text="$t('PostPayment.Manual.TableWork')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />
        <!--
        <b-row v-if="!editMode">
            <b-col>
                <MdButton
                    v-bind:Label="$t('PostPayment.Manual.SearchClaims')"
                    v-bind:Name="'btnSearchClaims'"
                    v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                    v-on:click="searchClaimsHandler"
                />
            </b-col>
        </b-row>
-->
        <b-row class="mt-2">
            <b-col>
                <md-editable-grid
                    ref="editableGrid"
                    :columns="filteredFields"
                    :rows="items"
                    :showMessageIsEmpty="showMessageIsEmpty"
                    :showSearch="true"
                    :totalRows="totalRows"
                    :dataKey="dataKey"
                    :frozenColumnAction="true"
                    :serverSidePagination="false"
                    :headerTitle="$t('Shared.Claim')"
                    @cell-edit-complete="cellEditCompleteHandler"
                    @cell-active="cellActiveHandler"
                    :footerRows="footerRows"
                >
                    <template #cell-multiAdjAmt="{cell, visible, close, update}">
                        <insurance-multi-adj-payment-posting-listing-modal
                            :visible.sync="visible"
                            @close="close"
                            @update="update"
                            v-bind="cell"
                        >
                        </insurance-multi-adj-payment-posting-listing-modal>
                    </template>
                </md-editable-grid>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import InsuranceMultiAdjPaymentPostingListingModal from './insMultiAdjPaymentPostingListingModal.vue';

export default {
    name: 'InsuranceHeaderPaymentPostingEntry',
    components: { InsuranceMultiAdjPaymentPostingListingModal },
    mixins: [ShowMessage, DBFunctions],
    props: {
        value: {
            type: Array,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: true
        },
        displayOption: {
            type: Number,
            required: true
        },
        insuranceCompany: {
            type: String,
            default: null
        }
    },
    computed: {
        editableGrid() {
            return this.$refs.editableGrid;
        },
        showMessageIsEmpty() {
            return this.items.length === 0;
        },
        totalRows() {
            return this.items.length;
        },
        toApply() {
            const apply = this.items.reduce((sum, p) => sum + (p.payProvider || 0), 0);
            return parseFloat((this.parameters.paymentAmount - apply).toFixed(2));
        },
        filteredFields() {
            const fields = [
                'issLineNo',
                'day_Unit',
                'cpt_hcpcs',
                'hcpcsCode',
                'primInsPay',
                'prevCoins',
                'prevDeductible',
                'prevDenied',
                'patientPay',
                'patientAdj',
                'adjustment'
            ];

            const insurance = (this.insuranceCompany || '').toUpperCase();
            const insuranceFields = [];
            if (
                !this.items.some(
                    x =>
                        !Utils.isNullOrEmptyString(x.primaryInsCompany) &&
                        (x.primaryInsCompany || '').toUpperCase() !== insurance
                )
            ) {
                insuranceFields.push('primaryInsCompany');
            }
            if (!this.items.some(x => !Utils.isNullOrEmptyString(x.secondaryInsCompany))) {
                insuranceFields.push('secondaryInsCompany');
            }
            if (!this.items.some(x => !Utils.isNullOrEmptyString(x.tertiaryInsCompany))) {
                insuranceFields.push('tertiaryInsCompany');
            }

            if (this.displayOption === 0) {
                return this.fields.filter(
                    field =>
                        !fields.some(x => x === field.key) &&
                        !insuranceFields.some(x => x === field.key)
                );
            }

            return this.fields.filter(field => !insuranceFields.some(x => x === field.key));
        },
        filteredItems() {
            return this.$refs.editableGrid?.filteredRows || this.items;
        },
        totalAdjAmt() {
            const adjAmtItems = this.filteredItems.reduce((arr, y) => {
                if (y.multiAdjAmt && Array.isArray(y.multiAdjAmt)) {
                    arr = arr.concat(y.multiAdjAmt);
                }
                return arr;
            }, []);
            return parseFloat(
                adjAmtItems.reduce((sum, p) => sum + (p.adjAmt || 0.0), 0.0).toFixed(2)
            );
        },

        footerRows() {
            const items = this.filteredItems;
            if (items.length === 0) {
                return [];
            }

            const item = {};
            const patientCodeList = [...new Set(items.map(x => x.patientCode))];

            item['patientCode'] = this.$t('DateRangeAttendance.Totals');
            item['amtCoins'] = parseFloat(
                items.reduce((sum, p) => sum + (p.amtCoins || 0.0), 0.0).toFixed(2)
            );
            item['patientName'] = patientCodeList.length;
            item['newBalance'] = parseFloat(
                items.reduce((sum, p) => sum + (p.newBalance || 0.0), 0.0).toFixed(2)
            );
            item['amtAllowed'] = parseFloat(
                items.reduce((sum, p) => sum + (p.amtAllowed || 0.0), 0.0).toFixed(2)
            );
            item['adjAmt'] = parseFloat(
                items.reduce((sum, p) => sum + (p.adjAmt || 0.0), 0.0).toFixed(2)
            );
            item['amtDeduct'] = parseFloat(
                items.reduce((sum, p) => sum + (p.amtDeduct || 0.0), 0.0).toFixed(2)
            );
            item['payBenefit'] = parseFloat(
                items.reduce((sum, p) => sum + (p.payBenefit || 0.0), 0.0).toFixed(2)
            );
            item['payProvider'] = parseFloat(
                items.reduce((sum, p) => sum + (p.payProvider || 0.0), 0.0).toFixed(2)
            );
            item['amtNonAllowed'] = parseFloat(
                items.reduce((sum, p) => sum + (p.amtNonAllowed || 0.0), 0.0).toFixed(2)
            );
            item['amtApproved'] = parseFloat(
                items.reduce((sum, p) => sum + (p.amtApproved || 0.0), 0.0).toFixed(2)
            );
            item['charges'] = parseFloat(
                items.reduce((sum, p) => sum + (p.charges || 0.0), 0.0).toFixed(2)
            );
            item['balance'] = parseFloat(
                items.reduce((sum, p) => sum + (p.balance || 0.0), 0.0).toFixed(2)
            );
            item['multiAdjAmt'] = this.totalAdjAmt;

            return [item];
        }
    },
    data() {
        const backgroundColor = '#c5c5c5 !important';
        //const color = '#FFF !important';

        return {
            paymentTypeOptions: EnumService.PaymentPostPaymentType.filter(x => x.value !== 0),
            paymentTypeVModel: null,
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            parameters: this.data || {
                paymentType: null,
                paymentDate: Utils.formatterNowToDate(),
                paymentReference: null,
                paymentAmount: null,
                sysDate: null,
                transNo: null
            },
            dataKey: 'rowKey',
            items: this.value || [],
            fields: [
                //READONLY COLUMNS
                {
                    key: 'patientCode',
                    label: this.$t('Shared.PatientCode'),
                    editable: false,
                    props: {
                        frozen: true,
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'patientName',
                    label: this.$t('Shared.PatientName'),
                    editable: false,
                    props: {
                        frozen: true,
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'issLineNo',
                    label: this.$t('Shared.LineNo'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'integer',
                        cellStyle: {
                            minWidth: '80px !important',
                            width: '80px',
                            backgroundColor: backgroundColor
                        },
                        headerStyle: { width: '80px' }
                    }
                },
                {
                    key: 'day_Unit',
                    label: this.$t('PostPayment.Manual.NumberSymbol'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'integer',
                        cellStyle: {
                            minWidth: '50px !important',
                            width: '50px',
                            backgroundColor: backgroundColor
                        },
                        headerStyle: { width: '50px' }
                    }
                },
                {
                    key: 'dateFrom',
                    label: this.$t('Shared.datefrom'),
                    editable: false,
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    },
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'dateTo',
                    label: this.$t('Shared.dateTo'),
                    editable: false,
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    },
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'cpt_hcpcs',
                    label: this.$t('Shared.CPT'),
                    editable: false,
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'hcpcsCode',
                    label: this.$t('Shared.HCPCS'),
                    editable: false,
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'primaryInsCompany',
                    label: this.$t('Shared.PrimaryInsurance'),
                    editable: false,
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'secondaryInsCompany',
                    label: this.$t('Shared.SecondaryInsurance'),
                    editable: false,
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'tertiaryInsCompany',
                    label: this.$t('Shared.TertiaryInsurance'),
                    editable: false,
                    props: {
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'amtApproved',
                    label: this.$t('PostPayment.Manual.Approved'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'charges',
                    label: this.$t('Shared.Charges'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                /*{
                    key: 'primInsPay',
                    label: this.$t('PostPayment.Manual.InsPay'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'adjustment',
                    label: this.$t('PostPayment.Manual.InsAdj'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'prevCoins',
                    label: this.$t('PostPayment.Manual.CoIns'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'prevDeductible',
                    label: this.$t('PostPayment.Manual.Deductible'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'prevDenied',
                    label: this.$t('PostPayment.Manual.Denied'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'patientPay',
                    label: this.$t('PostPayment.Manual.PatPay'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'patientAdj',
                    label: this.$t('PostPayment.Manual.PatAdj'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },*/
                {
                    key: 'balance',
                    label: this.$t('PostPayment.Manual.PrevBalance'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },
                {
                    key: 'newBalance',
                    label: this.$t('PostPayment.Manual.NewBalance'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                },

                //EDITABLE COLUMNS
                {
                    key: 'amtAllowed',
                    label: this.$t('PostPayment.Manual.Allowed'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'amtDeduct',
                    label: this.$t('PatientClaimList.Deduct'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'amtCoins',
                    label: this.$t('PostPayment.Manual.CoInsurance'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'payBenefit',
                    label: this.$t('PostPayment.Manual.DeniedAmount'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'amtNonAllowed',
                    label: this.$t('PostPayment.Manual.NonAllowed'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'adjAmt',
                    label: this.$t('PostPayment.Manual.Adj'),
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        step: 0.1,
                        round: 2,
                        allowNegativeValue: false,
                        inputType: 'decimal',
                        isCellEditableCallback: item => this.payCodeEditableCell(item)
                    }
                },
                {
                    key: 'payCode',
                    label: this.$t('PostPayment.PayCode'),
                    dataType: 'lookup',
                    editable: true,
                    focusable: true,
                    props: {
                        api: 'PostPayment/reasonPaymentLookup',
                        searchTitle: this.$t('PostPayment.PayCode'),
                        fieldCode: 'code',
                        fieldDescription: 'code',
                        searchFieldCode: 'Code',
                        valueDescription: 'payCodeDescription',
                        isCellEditableCallback: item => this.payCodeEditableCell(item),
                        fields: [
                            {
                                key: 'code',
                                sortable: true,
                                label: this.$t('Shared.Code'),
                                class: 'text-left'
                            },
                            {
                                key: 'description',
                                sortable: true,
                                label: this.$t('Shared.Description'),
                                class: 'text-left'
                            }
                        ]
                    }
                },
                {
                    key: 'reasonNo',
                    label: this.$t('PostPayment.ReasonNo'),
                    dataType: 'text',
                    editable: true,
                    focusable: true,

                    props: {
                        //MaxLength:4
                        isCellEditableCallback: item => this.payCodeEditableCell(item)
                    }
                },
                {
                    key: 'multiAdjAmt',
                    label: this.$t('PostPayment.Manual.MultiAdj'),
                    dataType: 'button',
                    editable: true,
                    focusable: true,
                    formatter: value => (value ? value.map(x => x.payCode).join(',') : '')
                },
                {
                    key: 'icnNumber',
                    label: this.$t('PatientClaimList.Icn'),
                    dataType: 'text',
                    editable: true,
                    focusable: true,
                    props: {
                        //MaxLength:20
                    }
                },
                {
                    key: 'payProvider',
                    label: this.$t('PostPayment.PayProvider'),
                    editable: false,
                    dataType: 'numeric',
                    props: {
                        inputType: 'decimal',
                        cellStyle: {
                            backgroundColor: backgroundColor
                        }
                    }
                }
            ],
            paymentTypeValid: true,
            paymentDateValid: true,
            paymentReferenceValid: true,
            rowKeyActive: null
        };
    },
    watch: {
        value(newValue) {
            this.items = newValue || [];
        },
        data(newValue) {
            this.parameters = newValue || {
                paymentType: null,
                paymentDate: null,
                paymentReference: null,
                paymentAmount: null,
                sysDate: null,
                transNo: null
            };
        }
    },
    methods: {
        changeDropDownPaymentType(value) {
            this.parameters.paymentType = value ? value.value : null;

            if (
                this.parameters.paymentType === 3 &&
                Utils.isNullOrEmptyString(this.parameters.paymentReference)
            ) {
                this.parameters.paymentReference = 'CASH';
            }
            this.$emit('change-data', this.parameters);
        },
        datePaymentInput(value) {
            this.parameters.paymentDate = value;
            this.$emit('change-data', this.parameters);
            this.emitChanged('payment-date', value);
        },
        editChanged() {
            this.$nextTick(() => this.$emit('change-data', this.parameters));
        },

        cellEditCompleteHandler({ rowKey, columnKey, value, lookupInfo }) {
            const rowIndex = this.indexOfFromItemRowKey(rowKey);

            if (rowIndex !== -1) {
                const isModified =
                    this.items[rowIndex]['isModified'] || this.items[rowIndex][columnKey] !== value;
                const backup = {
                    columnKey: columnKey,
                    value: this.items[rowIndex][columnKey]
                };
                this.items[rowIndex][columnKey] = value;

                if (columnKey === 'payCode' && lookupInfo) {
                    backup.payCodeDescription = this.items[rowIndex].payCodeDescription;
                    this.items[rowIndex].payCodeDescription = lookupInfo.code;
                }

                this.items[rowIndex]['isModified'] = isModified;
                this.emitChanged('payment-posting-cell', value);

                if (columnKey === 'multiAdjAmt') {
                    backup.adjAmt = this.items[rowIndex]['adjAmt'];
                    backup.reasonNo = this.items[rowIndex]['reasonNo'];
                    backup.payCode = this.items[rowIndex]['payCode'];
                    backup.payCodeDescription = this.items[rowIndex]['payCodeDescription'];
                    backup.multiAdjAmt = this.items[rowIndex]['multiAdjAmt'];

                    if (
                        this.items[rowIndex]['multiAdjAmt'] &&
                        Array.isArray(this.items[rowIndex]['multiAdjAmt']) &&
                        this.items[rowIndex]['multiAdjAmt'].length !== 0
                    ) {
                        this.items[rowIndex]['adjAmt'] = null;
                        this.items[rowIndex]['reasonNo'] = null;
                        this.items[rowIndex]['payCode'] = null;
                        this.items[rowIndex]['payCodeDescription'] = null;
                    } else {
                        this.items[rowIndex]['adjAmt'] = 0;
                        this.items[rowIndex]['multiAdjAmt'] = null;
                    }
                }

                if (columnKey === 'adjAmt' || columnKey === 'reasonNo' || columnKey === 'payCode') {
                    backup.multiAdjAmt = this.items[rowIndex]['multiAdjAmt'];
                    this.items[rowIndex]['multiAdjAmt'] = null;
                }

                const prevPayProvider = this.items[rowIndex]['payProvider'];
                const prevNewBalance = this.items[rowIndex]['newBalance'];

                this.items[rowIndex]['payProvider'] = parseFloat(
                    (
                        this.items[rowIndex]['amtAllowed'] +
                        this.items[rowIndex]['outlier'] -
                        (this.items[rowIndex]['amtNonAllowed'] +
                            this.items[rowIndex]['amtDeduct'] +
                            this.items[rowIndex]['amtCoins'] +
                            this.items[rowIndex]['payBenefit'])
                    ).toFixed(2)
                );

                this.items[rowIndex]['newBalance'] = parseFloat(
                    (
                        this.items[rowIndex]['balance'] -
                        this.items[rowIndex]['payProvider'] -
                        (this.items[rowIndex]['adjAmt'] + this.totalAdjAmt)
                    ).toFixed(2)
                );

                if (this.toApply !== 0) {
                    const amtApply = this.items.reduce((sum, x) => sum + x.payProvider, 0);

                    if (
                        this.parameters.paymentAmount > 0 &&
                        this.parameters.paymentAmount < amtApply
                    ) {
                        this.items[rowIndex]['newBalance'] = prevNewBalance;
                        this.items[rowIndex]['payProvider'] = prevPayProvider;
                        this.items[rowIndex][backup.columnKey] = backup.value;

                        if (backup.payCodeDescription) {
                            this.items[rowIndex].payCodeDescription = backup.payCodeDescription;
                        }

                        if (columnKey === 'multiAdjAmt') {
                            this.items[rowIndex]['adjAmt'] = backup.adjAmt;
                            this.items[rowIndex]['reasonNo'] = backup.reasonNo;
                            this.items[rowIndex]['payCode'] = backup.payCode;
                            this.items[rowIndex]['payCodeDescription'] = backup.payCodeDescription;
                            this.items[rowIndex]['multiAdjAmt'] = backup.multiAdjAmt;
                        }

                        if (
                            columnKey === 'adjAmt' ||
                            columnKey === 'reasonNo' ||
                            columnKey === 'payCode'
                        ) {
                            this.items[rowIndex]['multiAdjAmt'] = backup.multiAdjAmt;
                        }

                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('PostPayment.Manual.AmountInvalid'),
                            'error'
                        );
                    }
                }
            }
        },
        /*
        searchClaimsHandler() {
            this.$emit('search-claims');
        },
*/
        indexOfFromItemRowKey(rowKey) {
            return this.items.findIndex(x => x[this.dataKey] === rowKey);
        },

        validate_required() {
            this.paymentTypeValid =
                this.parameters.paymentType !== undefined && this.parameters.paymentType !== null;
            this.paymentDateValid = !Utils.isNullOrEmptyString(this.parameters.paymentDate);
            this.paymentReferenceValid = !Utils.isNullOrEmptyString(
                this.parameters.paymentReference
            );

            return this.paymentTypeValid && this.paymentDateValid && this.paymentReferenceValid;
        },

        emitChanged(componentName, value) {
            var changed = {
                Changed: true,
                Value: value,
                ComponentName: componentName
            };

            EventBus.$emit('onChanged', changed);
        },

        resetPaymentType(payType) {
            const indexOf = ['CHECK', 'CR CARD', 'CASH', 'OTHER', 'EFT'].indexOf(
                payType?.toUpperCase()
            );

            const paymentTypeVModel = EnumService.PaymentPostPaymentType.find(
                x => x.value === indexOf + 1
            );
            if (paymentTypeVModel) {
                this.paymentTypeVModel = paymentTypeVModel.value;
            }
        },

        payCodeEditableCell(item) {
            const rowIndex = this.indexOfFromItemRowKey(item.rowKey);

            if (rowIndex !== -1) {
                const multiAmtAdj = this.items[rowIndex]['multiAdjAmt'];

                if (multiAmtAdj && Array.isArray(multiAmtAdj) && multiAmtAdj.length !== 0) {
                    return false;
                }
            }

            return true;
        },

        cellActiveHandler(cell) {
            this.rowKeyActive = cell ? cell.rowKey : null;
        },

        autoApplyHandler() {
            if (this.rowKeyActive) {
                const rowIndex = this.indexOfFromItemRowKey(this.rowKeyActive);

                if (rowIndex !== -1) {
                    this.items[rowIndex]['amtAllowed'] = this.items[rowIndex]['balance'];
                    this.items[rowIndex]['payProvider'] = parseFloat(
                        (
                            this.items[rowIndex]['amtAllowed'] +
                            this.items[rowIndex]['outlier'] -
                            (this.items[rowIndex]['amtNonAllowed'] +
                                this.items[rowIndex]['amtDeduct'] +
                                this.items[rowIndex]['amtCoins'] +
                                this.items[rowIndex]['payBenefit'])
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['newBalance'] = parseFloat(
                        (
                            this.items[rowIndex]['balance'] -
                            this.items[rowIndex]['payProvider'] -
                            (this.items[rowIndex]['adjAmt'] + this.totalAdjAmt)
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['isModified'] = true;

                    this.emitChanged('payment-posting-cell', this.items[rowIndex]['balance']);
                }
            }
        },

        autoAdjustHandler() {
            if (this.rowKeyActive) {
                const rowIndex = this.indexOfFromItemRowKey(this.rowKeyActive);

                if (rowIndex !== -1) {
                    this.items[rowIndex]['multiAdjAmt'] = null;
                    this.items[rowIndex]['payProvider'] = parseFloat(
                        (
                            this.items[rowIndex]['amtAllowed'] +
                            this.items[rowIndex]['outlier'] -
                            (this.items[rowIndex]['amtNonAllowed'] +
                                this.items[rowIndex]['amtDeduct'] +
                                this.items[rowIndex]['amtCoins'] +
                                this.items[rowIndex]['payBenefit'])
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['adjAmt'] =
                        this.items[rowIndex]['charges'] -
                        (this.items[rowIndex]['payProvider'] +
                            this.items[rowIndex]['outlier'] +
                            this.items[rowIndex]['amtCoins'] +
                            this.items[rowIndex]['amtDeduct']);
                    this.items[rowIndex]['newBalance'] = parseFloat(
                        (
                            this.items[rowIndex]['balance'] -
                            this.items[rowIndex]['payProvider'] -
                            (this.items[rowIndex]['adjAmt'] + this.totalAdjAmt)
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['isModified'] = true;

                    this.emitChanged('payment-posting-cell', this.items[rowIndex]['balance']);
                }
            }
        },

        applyDeniedHandler() {
            if (this.rowKeyActive) {
                const rowIndex = this.indexOfFromItemRowKey(this.rowKeyActive);

                if (rowIndex !== -1) {
                    this.items[rowIndex]['amtAllowed'] = this.items[rowIndex]['balance'];
                    this.items[rowIndex]['payBenefit'] = this.items[rowIndex]['balance'];
                    this.items[rowIndex]['payProvider'] = parseFloat(
                        (
                            this.items[rowIndex]['amtAllowed'] +
                            this.items[rowIndex]['outlier'] -
                            (this.items[rowIndex]['amtNonAllowed'] +
                                this.items[rowIndex]['amtDeduct'] +
                                this.items[rowIndex]['amtCoins'] +
                                this.items[rowIndex]['payBenefit'])
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['newBalance'] = parseFloat(
                        (
                            this.items[rowIndex]['balance'] -
                            this.items[rowIndex]['payProvider'] -
                            (this.items[rowIndex]['adjAmt'] + this.totalAdjAmt)
                        ).toFixed(2)
                    );
                    this.items[rowIndex]['isModified'] = true;

                    this.emitChanged('payment-posting-cell', this.items[rowIndex]['balance']);
                }
            }
        }
    }
};
</script>
